module.exports = __webpack_public_path__ + "static/media/The World Inside.d269d2ec.jpg";